import useGetUserSettingsQuery from './queries/useGetUserSettingsQuery';

export const useIsCaUser = () => {
  const { data: userSettings } = useGetUserSettingsQuery();
  return (
    userSettings?.isInitialized && userSettings.regions.find((r) => r.region === 'CA' && r.country == 'US') != null
  );
};
